export default __webpack_public_path__ + "static/photoelectric4-d339eed2edd52ea9a83c723684cac62c.png";